
  const dots = document.querySelectorAll('.dot'); // get all the dot elements
  const blocks = document.querySelectorAll('[data-id]'); // get all elements with data-id attribute
  //console.log(dots);
  dots.forEach(dot => {
    dot.addEventListener('mouseover', () => {
      dot.classList.add('hovered'); // add hovered class to the dot element
      blocks.forEach(block => {
        if (block.getAttribute('data-id') === dot.getAttribute('data-id')) { // if data-id matches the dot's block id
          block.classList.add('hovered'); // add hovered class to the matching block
        }
      });
    });
  
    dot.addEventListener('mouseout', () => {
      dot.classList.remove('hovered'); // remove hovered class from the dot element
      blocks.forEach(block => {
        if (block.getAttribute('data-id') === dot.getAttribute('data-id')) { // if data-id matches the dot's block id
          block.classList.remove('hovered'); // remove hovered class from the matching block
        }
      });
    });
  });
  
  blocks.forEach(block => {
    block.addEventListener('mouseover', () => {
      blocks.forEach(otherBlock => {
        const dot = document.querySelector(`.dot[data-id="${block.getAttribute('data-id')}"]`);
        if (otherBlock.getAttribute('data-id') === block.getAttribute('data-id')) { // if data-id matches the hovered block's id
          otherBlock.classList.add('hovered'); // add hovered class to the hovered block
          if (dot) {
            dot.classList.add('hovered'); // add hovered class to the matching dot element
          }
        }
      });
    });
  
    block.addEventListener('mouseout', () => {
      blocks.forEach(otherBlock => {
        const dot = document.querySelector(`.dot[data-id="${block.getAttribute('data-id')}"]`);
        if (otherBlock.getAttribute('data-id') === block.getAttribute('data-id')) { // if data-id matches the hovered block's id
          otherBlock.classList.remove('hovered'); // remove hovered class from the hovered block
          if (dot) {
            dot.classList.remove('hovered'); // remove hovered class from the matching dot element
          }
        }
      });
    });
  });
